import {
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
} from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { Lunar } from 'lunar-typescript';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import iconArrive from '../../../assets/images/booking/icon-arrive.svg';
import iconDepart from '../../../assets/images/booking/icon-depart.svg';
import iconDown from '../../../assets/images/booking/icon-down.svg';
import iconCustomer from '../../../assets/images/changeBooking/icon-customer.svg';
import iconDelete from '../../../assets/images/changeBooking/icon-delete.svg';
import iconRoute from '../../../assets/images/changeBooking/icon-route.svg';
import iconSeat from '../../../assets/images/changeBooking/icon-seat.svg';
import iconSwitch from '../../../assets/images/changeBooking/icon-switch.svg';
import iconTicket from '../../../assets/images/changeBooking/icon-ticket.svg';
import '../../../assets/styles/desktop/busBooking.scss';
import { Constant, DateFormat, YearFormat } from '../../../config/constant';
import { Message } from '../../../config/message';
import { convertTimeFormat, filterOption } from '../../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  getSegmentDataBooking,
  moveBookingSelector,
  postMoveBooking,
  resetPostMoveBooking,
} from '../../../redux/slice/bookings/bookingTicketSlice';
import {
  getAvailableSeat,
  moveTicketSelector,
  resetListAvailableSeat,
  resetMoveTicket,
} from '../../../redux/slice/bookings/moveTicketSlice';

const ModalChangeBooking: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  listBooking,
  listBookingDetail,
  selectedSeatChangeBooking,
  searchDateBooking,
}) => {
  const { listAvailableSeat, loading: loadingAvailable } = useAppSelector(moveTicketSelector);
  const { loading, loadingCreate, listDataBookingSeat, listSegmentBooking, statusMove } =
    useAppSelector(moveBookingSelector);
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const { t } = useTranslation();
  const [formChangeBooking]: [FormInstance] = Form.useForm();
  const pickUpValue = Form.useWatch('pickup_location_id', formChangeBooking);
  const dropOffValue = Form.useWatch('drop_off_location_id', formChangeBooking);
  const watchScheduleId = Form.useWatch('schedule_id', formChangeBooking);
  const watchDepartDate = dayjs(Form.useWatch('depart_date', formChangeBooking)).format(YearFormat);
  const watchTicket = Form.useWatch('tickets', formChangeBooking);
  const segmentId = Form.useWatch('segment_id', formChangeBooking);
  const dispatch = useAppDispatch();
  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };
  const modalHandleCancel = () => {
    formChangeBooking.resetFields();
    dispatch(resetMoveTicket());
    dispatch(resetListAvailableSeat());
    dispatch(resetPostMoveBooking());
    onCancel();
  };
  const RouteRules = [
    {
      required: true,
      message: t(Message.ROUTE),
    },
  ];
  const filterOptionRoute = (
    input: string,
    option?: {
      label: string;
      value: string;
    },
  ) => (option?.label ?? '').toLowerCase()?.includes(input.toLowerCase());

  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      formChangeBooking.scrollToField(firstErrorField.name);
    }
  };

  const handleOptionPickup = () => {
    let options: any = [];
    if (listAvailableSeat?.transship_depart?.length) {
      options = options.concat(
        listAvailableSeat?.transship_depart?.length
          ? listAvailableSeat?.transship_depart?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (listAvailableSeat?.is_depart_transship) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const handleOptionDropOff = () => {
    let options: any = [];
    if (listAvailableSeat?.transship_arrive?.length) {
      options = options.concat(
        listAvailableSeat?.transship_arrive?.length
          ? listAvailableSeat?.transship_arrive?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (listAvailableSeat?.is_arrive_transship) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current < dayjs().startOf('day');
  };

  const handleSearchAvailable = () => {
    const dataSearchValue = {
      schedule_id: formChangeBooking.getFieldValue('route_id'),
      old_ticket_codes: listBookingDetail?.id
        ? [listBookingDetail?.ticket_code]
        : listDataBookingSeat?.length
        ? listDataBookingSeat?.map((booking: any) => booking?.ticket_code)
        : [],
      depart_date: dayjs(formChangeBooking.getFieldValue('depart_date')).format(YearFormat),
      segment_id: formChangeBooking.getFieldValue('segment_id'),
      is_move_waiting: false,
    };
    formChangeBooking.setFieldsValue({
      pickup_location_id: undefined,
      drop_off_location_id: undefined,
      pickup_extra: undefined,
      drop_off_extra: undefined,
      tickets: watchTicket?.length
        ? watchTicket?.map((ticket: any) => ({
            ...ticket,
            seat_number: '',
          }))
        : [],
    });
    dispatch(getAvailableSeat(dataSearchValue));
  };

  const onFinish = (values: any) => {
    if (values?.tickets?.length || !listBooking?.schedule?.is_diagram) {
      values.tickets =
        values.tickets?.map(({ old_ticket, seat_number }: any) => ({
          old_ticket,
          seat_number,
        })) || [];
      values.old_ticket_code = undefined;
      values.depart_date = dayjs(formChangeBooking.getFieldValue('depart_date')).format(YearFormat);
      values.schedule_id = undefined;
      dispatch(postMoveBooking(values));
    } else {
      if (Array.isArray(listAvailableSeat?.available_seats)) {
        toast.error('Vui lòng nhập ghế muốn chuyển');
      } else {
        values.old_ticket_code = undefined;
        values.depart_date = dayjs(formChangeBooking.getFieldValue('depart_date')).format(YearFormat);
        values.schedule_id = undefined;
        values.tickets =
          values.tickets?.map(({ old_ticket, seat_number }: any) => ({
            old_ticket,
            seat_number,
          })) || [];
        dispatch(postMoveBooking(values));
      }
    }
  };

  useEffect(() => {
    if (watchDepartDate) {
      dispatch(
        getSegmentDataBooking({
          depart_date: watchDepartDate,
          schedule_id: watchScheduleId ? watchScheduleId : undefined,
        }),
      );
    }
  }, [dispatch, watchDepartDate, watchScheduleId]);

  useEffect(() => {
    if (watchScheduleId && listSegmentBooking?.segments?.length === 1) {
      formChangeBooking.setFieldValue('segment_id', listSegmentBooking?.segments[0]?.segment_id);
    }
  }, [listSegmentBooking, watchScheduleId]);

  useEffect(() => {
    if (statusMove === Constant.DEFAULT_STATUS) {
      modalHandleCancel();
    }
  }, [statusMove]);

  useEffect(() => {
    if (listDataBookingSeat?.length) {
      const initialValues = listDataBookingSeat?.map((booking: any) => ({
        old_ticket: booking?.ticket_code,
        old_seat_number: booking?.seat_number,
        seat_number: '',
        customer_name: booking?.customer_name,
        customer_phone: booking?.customer_phone,
        start_location: booking?.start_location,
        end_location: booking?.end_location,
      }));
      formChangeBooking.setFieldValue('tickets', initialValues);
    }
  }, [listDataBookingSeat]);

  useEffect(() => {
    if (listAvailableSeat?.transship_depart?.length === 1 && !listAvailableSeat?.is_depart_transship) {
      formChangeBooking.setFieldValue('pickup_location_id', listAvailableSeat?.transship_depart[0]?.id);
    }
    if (listAvailableSeat?.transship_arrive?.length === 1 && !listAvailableSeat?.is_arrive_transship) {
      formChangeBooking.setFieldValue('drop_off_location_id', listAvailableSeat?.transship_arrive[0]?.id);
    }
  }, [listAvailableSeat]);

  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      centered
      footer={[]}
      width={1000}
      maskClosable={false}
      className="modal-bus-booking"
    >
      <Spin spinning={loading || loadingCreate || loadingAvailable}>
        <Card className="card-modal-booking change">
          <Form
            layout="vertical"
            className="form-booking-multi"
            form={formChangeBooking}
            onFinish={onFinish}
            autoComplete="off"
            validateTrigger="onSubmit"
            labelAlign={'left'}
            labelWrap
            onFieldsChange={(allFields) => {
              scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
            }}
            initialValues={{
              depart_date: searchDateBooking ? dayjs(searchDateBooking) : dayjs(),
            }}
          >
            <div className="border-booking-title">
              <Typography.Text className="fw-600 fs-18 ">{t('Chuyển vé')}</Typography.Text>
            </div>
            <Row className="mt-1">
              <Typography className="fw-500 fs-16">
                Tuyến:
                <span className="fw-600 fs-16">
                  {` ${
                    listBooking?.schedule?.stops?.length > 0
                      ? listBooking?.schedule?.stops?.map((item: any) => item?.name)?.join(' -> ')
                      : ''
                  } `}
                </span>
              </Typography>
            </Row>
            <Row className="mt-1">
              <Typography className="fw-500 fs-16">
                Thời gian đi:{' '}
                <span className="fw-600 fs-16">{`${listBooking?.schedule?.depart_time?.slice(0, 5)} - ${
                  listBooking?.schedule?.depart_date
                }`}</span>
              </Typography>
            </Row>
            <div className="block-content-booking-change">
              <div className="change-booking-content mt-3">
                <div className="booking-info-block success">
                  <div className="booking-info-title bg-success-1">Thông tin chuyển vé</div>
                  <Row gutter={8} className="w-100">
                    <Col span={4}>
                      <Form.Item
                        name="depart_date"
                        className="data-picker booking"
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <DatePicker
                          className="w-100 input-h40"
                          format={DateFormat}
                          placeholder={t('Chọn ngày đi')}
                          changeOnBlur
                          disabledDate={disabledDate}
                          onChange={() => {
                            formChangeBooking.setFieldsValue({
                              schedule_id: undefined,
                              segment_id: undefined,
                              pickup_location_id: undefined,
                              drop_off_location_id: undefined,
                              pickup_extra: undefined,
                              drop_off_extra: undefined,
                            });
                            dispatch(resetListAvailableSeat());
                          }}
                          defaultValue={dayjs(new Date())}
                          allowClear={false}
                          cellRender={(current: any) => {
                            // @ts-ignore
                            let d = Lunar.fromDate(new Date(current));
                            const lunar = d.getDay();
                            const lunarMonth = d.getMonth();
                            return (
                              <div>
                                <div className="fs-14 fw-500">{current.date()}</div>
                                <div className="fs-12 lunar fw-500">
                                  {lunar}
                                  {
                                    // eslint-disable-next-line
                                    lunar == 1 || current.date() == 1 ? `/${lunarMonth}` : null
                                  }
                                </div>
                              </div>
                            );
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        name="schedule_id"
                        className="form-item-name route-select booking"
                        validateTrigger={['onChange', 'onBlur']}
                        rules={RouteRules}
                      >
                        <Select
                          className="input-h40 w-100"
                          showSearch
                          placeholder="Chọn tuyến"
                          filterOption={filterOptionRoute}
                          size="large"
                          disabled={!watchDepartDate}
                          onChange={() => {
                            formChangeBooking.setFieldsValue({
                              segment_id: undefined,
                              pickup_location_id: undefined,
                              drop_off_location_id: undefined,
                              pickup_extra: undefined,
                              drop_off_extra: undefined,
                            });
                            dispatch(resetListAvailableSeat());
                          }}
                          options={
                            listSegmentBooking?.schedules?.length
                              ? listSegmentBooking?.schedules?.map((schedule: any) => {
                                  return {
                                    value: schedule?.id,
                                    label: (
                                      <p>
                                        {schedule?.route?.depart_point} - {schedule?.route?.arrive_point} (
                                        {schedule?.depart_time ? schedule?.depart_time?.slice(0, 5) : ''}){' '}
                                        <span className={`${schedule?.is_diagram ? '':'required'}`}></span>
                                      </p>
                                    ),
                                  };
                                })
                              : []
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={7}>
                      <Form.Item name="segment_id" className="form-item-name" validateTrigger={['onChange', 'onBlur']}>
                        <Select
                          className="input-h40"
                          showSearch
                          suffixIcon={<img src={iconDown} alt="" />}
                          placeholder="Chọn chặng"
                          size="large"
                          onChange={() => {
                            formChangeBooking.setFieldsValue({
                              pickup_location_id: undefined,
                              drop_off_location_id: undefined,
                              pickup_extra: undefined,
                              drop_off_extra: undefined,
                            });
                            dispatch(resetListAvailableSeat());
                          }}
                          style={{ width: '100%' }}
                          defaultValue={undefined}
                          disabled={!watchScheduleId}
                          options={
                            listSegmentBooking?.segments?.length
                              ? listSegmentBooking?.segments?.map((item: any) => {
                                  return {
                                    value: item?.segment_id,
                                    label: `${item?.start_location} - ${item?.end_location}`,
                                  };
                                })
                              : []
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Form.Item name="old_ticket_code" className="d-none">
                      <Input disabled className="input-h40 border-r-2" />
                    </Form.Item>
                    <Col span={3}>
                      <Button className="search-btn" htmlType="button" onClick={() => handleSearchAvailable()}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                  <Typography className="fw-600 text-blue">Chọn điểm đón, trả</Typography>
                  <Row gutter={16} className="mt-1 w-100">
                    <Col span={12}>
                      <Form.Item
                        name="pickup_location_id"
                        className="form-item-name require"
                        validateTrigger={['onChange', 'onBlur']}
                        rules={[{ required: true, message: 'Vui lòng chọn điểm đón' }]}
                      >
                        <Select
                          className="input-h40"
                          placeholder={
                            <>
                              <img src={iconDepart} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm
                              đón
                            </>
                          }
                          size="large"
                          style={{ width: '100%' }}
                          options={handleOptionPickup()}
                          showSearch
                          filterOption={filterOption}
                          suffixIcon={<img src={iconDown} alt="" />}
                          disabled={!segmentId || !listAvailableSeat?.transship_depart?.length}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="drop_off_location_id"
                        className="form-item-name require"
                        validateTrigger={['onChange', 'onBlur']}
                        rules={[{ required: true, message: 'Vui lòng chọn điểm trả' }]}
                      >
                        <Select
                          className="input-h40"
                          placeholder={
                            <>
                              <img src={iconArrive} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm
                              trả
                            </>
                          }
                          size="large"
                          style={{ width: '100%' }}
                          options={handleOptionDropOff()}
                          showSearch
                          filterOption={filterOption}
                          suffixIcon={<img src={iconDown} alt="" />}
                          disabled={!segmentId || !listAvailableSeat?.transship_arrive?.length}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16} className="transship-extra mt-3 w-100">
                    {pickUpValue === 'other' && (
                      <Col span={12}>
                        <Form.Item
                          name="pickup_extra"
                          className="form-item-name require"
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          <Input placeholder="Chọn điểm đón khác" size="large" style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    )}
                    {pickUpValue !== 'other' && dropOffValue === 'other' && <Col span={12}></Col>}
                    {dropOffValue === 'other' && (
                      <Col span={12}>
                        <Form.Item
                          name="drop_off_extra"
                          className="form-item-name require"
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          <Input placeholder="Nhập điểm trả khác" size="large" style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </div>
                <div className="booking-info-block customer info mt-3">
                  <div className="booking-info-title bg-info-1">Danh sách hành khách</div>
                  <Form.List name="tickets">
                    {(fields, { remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => {
                          const ticket = formChangeBooking.getFieldValue(['tickets', index]) || {};
                          const availableGroupedSeats =
                            Array.isArray(listAvailableSeat?.available_seats) &&
                            listAvailableSeat?.available_seats?.length
                              ? listAvailableSeat?.available_seats?.map((group: any) => ({
                                  name: group?.name,
                                  available_seats: group?.available_seats?.filter(
                                    (seat: string) =>
                                      seat === ticket?.seat_number ||
                                      !formChangeBooking
                                        .getFieldValue('tickets')
                                        ?.some((t: any) => t?.seat_number === seat),
                                  ),
                                }))
                              : [];
                          return (
                            <div key={key} className="d-flex items-center gap-x-16">
                              <div className="d-flex items-center gap-x-12" style={{ width: '90px' }}>
                                <img src={iconTicket} alt="" />
                                <p className="fs-16 fw-500 text-blue">{ticket?.old_ticket}</p>
                              </div>

                              <div className="d-flex gap-x-12 items-center" style={{ width: '210px' }}>
                                <img src={iconCustomer} alt="" />
                                <div>
                                  <p className="fs-16 fw-500 text-blue">{ticket?.customer_name}</p>
                                  <p className="fs-16 fw-500 text-blue">{ticket?.customer_phone}</p>
                                </div>
                              </div>

                              <div className="d-flex items-center gap-x-12" style={{ width: '250px' }}>
                                <img src={iconRoute} alt="" />
                                <p className="fs-16 fw-500 text-blue">{`${ticket?.start_location} - ${ticket?.end_location}`}</p>
                              </div>
                              <div className="d-flex items-center gap-x-4">
                                <img src={iconSeat} alt="" />
                                <p className="fs-16 fw-500 text-blue">{ticket?.old_seat_number ?? ''}</p>
                                <img src={iconSwitch} alt="" />
                              </div>

                              {Array.isArray(listAvailableSeat?.available_seats) && (
                                <Form.Item
                                  {...restField}
                                  name={[name, 'seat_number']}
                                  style={{ margin: 0 }}
                                  rules={[{ required: true, message: 'Vui lòng chọn ghế' }]}
                                  validateTrigger={['onChange', 'onBlur']}
                                >
                                  <Select
                                    style={{ width: 110 }}
                                    placeholder="Chọn ghế"
                                    allowClear={false}
                                    disabled={!listAvailableSeat?.available_seats?.length}
                                  >
                                    {availableGroupedSeats?.map((group: any) => (
                                      <Select.OptGroup key={group?.name} label={group?.name}>
                                        {group?.available_seats.map((seat: string) => (
                                          <Select.Option key={seat} value={seat}>
                                            {seat}
                                          </Select.Option>
                                        ))}
                                      </Select.OptGroup>
                                    ))}
                                  </Select>
                                </Form.Item>
                              )}

                              <Button
                                type="link"
                                danger
                                icon={<img src={iconDelete} alt="" />}
                                onClick={() => {
                                  if (fields.length > 1) {
                                    remove(name);
                                  } else {
                                    toast.error('Phải còn ít nhất 1 hành khách');
                                  }
                                }}
                              />
                            </div>
                          );
                        })}
                      </>
                    )}
                  </Form.List>
                </div>

                {Array.isArray(listAvailableSeat?.available_seats) ? (
                  <div className="booking-info-block seat block-list-seat mt-4 success">
                    <Row className="d-flex items-start justify-between">
                      <Col>
                        <div className="booking-info-title bg-success-1">Danh sách ghế còn trống</div>
                      </Col>
                    </Row>
                    {listAvailableSeat?.available_seats?.length
                      ? listAvailableSeat?.available_seats?.map((listAvailable: any, listAvailableIndex: number) => (
                          <div key={`available-list-${listAvailableIndex}`} className="mt-2">
                            <div
                              className={`${listAvailableIndex === 1 ? 'bg-floor1' : 'bg-floor2'}`}
                              style={{ width: 'max-content' }}
                            >
                              <div style={{ width: 'fit-content' }}>{listAvailable?.name}</div>
                            </div>
                            <Flex gap={20} className="mt-3">
                              <div className="seat-floor-1">
                                {listAvailable?.available_seats?.map((seat: any, seatIndex: number) => {
                                  return (
                                    <>
                                      <div
                                        className={`d-flex items-center justify-content-center ${
                                          seat ? 'card-agent-seat' : ''
                                        }`}
                                        key={`floor-${seatIndex}`}
                                      >
                                        <div
                                          className="block-seat-name-item"
                                          style={
                                            watchTicket?.length
                                              ? watchTicket?.some((item: any) => item.seat_number === seat)
                                                ? { opacity: '40%' }
                                                : {}
                                              : {}
                                          }
                                        >
                                          <div className="fw-500">Ghế {seat}</div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            </Flex>
                          </div>
                        ))
                      : (listAvailableSeat?.transship_depart?.length ||
                          listAvailableSeat?.transship_depart?.length) && (
                          <Typography className="fw-500 fs-16 text red mt-1">Không tìm thấy ghế phù hợp</Typography>
                        )}
                  </div>
                ) : (
                  <div>
                    <p className="fs-16 fw-600 text-blue">
                      Số lượng ghế còn trống:{' '}
                      <span className="fs-16 fw-600 text-success">{listAvailableSeat?.available_seats}</span>{' '}
                    </p>
                    <p className="fs-14 fw-500 mt-3" style={{ color: '#009EF8' }}>
                      *Chuyến này không có sơ đồ
                    </p>
                  </div>
                )}
              </div>
            </div>
            <Row className="d-flex pt-3 gap-x-12 items-center justify-between">
              {listBooking?.schedule?.is_diagram ? (
                <Col style={{ display: 'flex', columnGap: '12px' }}>
                  <Typography className="fw-500 fs-16">
                    Ghế đang chọn:
                    <span style={{ color: '#3AB54A' }} className="fw-600">
                      {` ${
                        listDataBookingSeat?.length
                          ? listDataBookingSeat?.map((seat: any) => seat?.seat_number).join(' ,')
                          : ''
                      }`}
                    </span>
                  </Typography>
                </Col>
              ) : (
                <Col style={{ display: 'flex', columnGap: '12px' }}></Col>
              )}
              <Col className="d-flex gap-x-12">
                <Button key="cancel" className=" w-160 h-btn-48" onClick={() => modalHandleCancel()}>
                  {cancelText}
                </Button>
                <Button key="ok" type="primary" className="w-160 h-btn-48 btn-success mr-0" htmlType="submit">
                  {okText}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
    </Modal>
  );
};
export default ModalChangeBooking;
